import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent } from 'mbs-ui-kit';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { ErrorType, ImagePathByErrorType } from './error.constants';

@Component({
  selector: 'mbs-error',
  templateUrl: 'error.component.html',
  host: { class: 'text-center d-flex justify-content-center align-items-center flex-column' },
  imports: [ButtonComponent, CommonModule, I18NextPipe]
})
export class ErrorComponent {
  private router = inject(Router);

  readonly errorType = ErrorType;
  readonly imagePath = ImagePathByErrorType;
  @Input() type: ErrorType;
  @Input() hideNotFoundLink = false;

  refresh() {
    location.reload();
  }

  getI18NPath(part: string) {
    return `shared:error.type.${this.type}.${part}`;
  }

  goToDashboardRoute() {
    this.router.navigateByUrl(RoutingPath.ApDashboard);
  }
}
